import { orgNoSchema } from '#shared/organization-number'
import { safeEnum } from '#shared/core'
import { array, nullish, number, object, picklist, string } from 'valibot'

export { licensedProductSchema, orgSchema, roleSchema, sourceSchema, userSchema } from '#shared/core'
export type { CoreOrganization, CoreRole, CoreSource, LicensedProduct, SessionUserInfoDto } from '#shared/core'


export const orgSourceSchema = picklist(['NSR', 'LOCAL', 'FEIDE'])

export const organizationSchema = object({
  organizationNumber: orgNoSchema,
  organizationSource: orgSourceSchema,
  numberOfPupils: nullish(number()),
  numberOfPupilsOverride: nullish(number()),
  minimumLicenses: nullish(number()),
  hasDiscounts: array(
    object({
      discountType: safeEnum(picklist(['AUNIVERS_SCHOOL_LICENSE_OWNER'])),
      eans: array(string()),
    }),
  ),
})